// extracted by mini-css-extract-plugin
export default {"wrapper":"contact_wrapper__CD0a5"};